import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Filter } from '../../careers/browse-jobs/browse-jobs.component';
import {
  I9Employees_Result,
  LookupOnboardLocations_Result,
  LookupOnboardProfiles_Result,
} from '../../../type-definitions/onboard/responses/onboard';
import { I9AuditReportBulk } from '../../../type-definitions/onboard/requests/onboard';
import { ApiResponse, ReportGenerationApiResponse } from '../../../shared/model/api-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HiringService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  profilesGetForInvite() {
    const url = '/Hiring/ProfilesGetForInvite';
    return this.http.get(url).toPromise();
  }

  getDashboard(onboardID: any, status?: string) {
    const url = '/Hiring/GetDashboard?onboardID=' + onboardID + (status != null ? '&status=' + status : '');
    return this.http.get(url).toPromise();
  }

  getProcessData() {
    const url = '/Hiring/getProcessData';
    return this.http.get(url).toPromise();
  }

  getHiredData() {
    const url = '/Hiring/getHiredData';
    return this.http.get(url).toPromise();
  }

  getBirdDogOnboardToExclude() {
    const url = '/Hiring/GetBirdDogOnboardToExclude';
    return this.http.get(url).toPromise();
  }

  i9GenList(fromDateStr: string, toDateStr: string) {
    const url = '/Hiring/I9GenList?fromDateStr=' + fromDateStr + '&toDateStr=' + toDateStr;
    return this.http.get(url).toPromise();
  }

  i9Gen(employeeList: any[], fromDateStr: string, toDateStr: string) {
    return this.http
      .post('/Hiring/I9Gen', {
        employeeList: employeeList,
        fromDateStr: fromDateStr,
        toDateStr: toDateStr,
      })
      .toPromise();
  }

  sendI9Update(onboardID: any) {
    return this.http
      .post('/Hiring/I9Step2AttachmentUpdate', {
        onboardID: onboardID,
      })
      .toPromise();
  }

  getRaceCodes() {
    const url = '/Hiring/GetRaceCodes';
    return this.http.get(url).toPromise();
  }
  getOnboardEmergencyContacts(onboardID?: any) {
    const url = '/Hiring/GetOnboardEmergencyContacts?onboardID=' + onboardID;
    return this.http.get(url).toPromise();
  }

  maxNumberOfAttachments() {
    const url = '/Hiring/MaxNumberOfAttachments';
    return this.http.get(url).toPromise();
  }

  getMaritalStatus() {
    const url = '/Hiring/GetMaritalStatus';
    return this.http.get(url).toPromise();
  }

  getOnboardingEmployees(employeeLabel: string) {
    const url = '/Hiring/GetOnboardingEmployees?searchText=' + employeeLabel;
    return this.http.get(url).toPromise();
  }

  defaultsGetAllList(data: any) {
    const url = '/Hiring/DefaultsGetAllList?onboardProfileID=' + data;
    return this.http.get(url).toPromise();
  }

  getTasksByOnboardID(data?: any) {
    const url = '/Hiring/GetTasksByOnboardID?inputGuid=' + data;
    return this.http.get(url).toPromise();
  }

  getApplicantsByJobReq(onboardID: any) {
    const url = '/Applicant/GetApplicantsByJobReq?onboardID=' + onboardID;
    return this.http.get(url).toPromise();
  }

  personalInfoEdit(
    onboardID: any,
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    cell: string,
    zip: string,
    contact: string,
    contactSource: string,
    contactSourceNotes: string,
    hireDateStr: string,
    country: string,
    midName: string,
    suffix: string,
    hRRMKeyID: number,
    birthdayStr: string,
    maritalStatus: string,
    countryOther: string,
    isManagerEdit: boolean,
    reservedHRRef: number,
    reservedHRCo: number
  ) {
    return this.http
      .post('/Applicant/PersonalInfoEdit', {
        onboardID: onboardID,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        cell: cell,
        zip: zip,
        contact: contact,
        contactSource: contactSource,
        contactSourceNotes: contactSourceNotes,
        hireDateStr: hireDateStr,
        country: country,
        midName: midName,
        suffix: suffix,
        hRRMKeyID: hRRMKeyID,
        birthdayStr: birthdayStr,
        maritalStatus: maritalStatus,
        countryOther: countryOther,
        isManagerEdit: isManagerEdit,
        reservedHRRef: reservedHRRef,
        reservedHRCo: reservedHRCo,
      })
      .toPromise();
  }

  insertOnboardTasks(onboardID: any, onboardTaskDefID: number) {
    return this.http
      .post('/Hiring/InsertOnboardTasks', {
        onboardID: onboardID,
        onboardTaskDefID: onboardTaskDefID,
      })
      .toPromise();
  }

  updateArchiveByOnboardID(data) {
    return this.http
      .post('/Hiring/UpdateArchiveByOnboardID', {
        onboardID: data,
      })
      .toPromise();
  }
  applicantNotesGet(reqApplicantID: any) {
    const url = '/Applicant/ApplicantNotesGet?reqApplicantID=' + reqApplicantID;
    return this.http.get(url).toPromise();
  }

  applicantNotesAddEdit(reqApplicantID: any, noteText: string, reqID: any, reqApplicantNoteID?: number) {
    return this.http
      .post('/Applicant/ApplicantNotesAddEdit', {
        reqApplicantID: reqApplicantID,
        noteText: noteText,
        reqID: reqID,
        reqApplicantNoteID: reqApplicantNoteID,
      })
      .toPromise();
  }

  applicantNotesRemove(reqApplicantID: any, reqApplicantNoteID?: number) {
    return this.http
      .post('/Applicant/ApplicantNotesRemove', {
        reqApplicantID: reqApplicantID,
        reqApplicantNoteID: reqApplicantNoteID,
      })
      .toPromise();
  }

  getDependentLookupByColumnName(columnName: string, countryCode?: string) {
    const url =
      '/Hiring/GetDependentLookupByColumnName?columnName=' + columnName + (countryCode != null ? '&countryCode=' + countryCode : '');
    return this.http.get(url).toPromise();
  }

  getI9ForOnboardee(): Promise<object> {
    const url = '/Hiring/GetI9ForOnboardee';
    return this.http.get<object>(url).toPromise();
  }

  getI9ByOnboardID(id: string): Promise<object> {
    const url = '/Hiring/GetI9ByOnboardID';
    const params = new HttpParams().set('onboardID', id);
    return this.http.get<object>(url, { params: params }).toPromise();
  }

  oNGetI9ByOnboardIDStep2(id: any) {
    const url = '/Hiring/ONGetI9ByOnboardIDStep2?onboardID=' + id;
    return this.http.get(url).toPromise();
  }

  updateI9ByOnboardIDPart2(formData2: any) {
    const payload = new URLSearchParams();
    payload.set('onboardID', formData2.OnboardID);
    payload.set('s2EmpLastName', formData2.S2EmpLastName ?? '');
    payload.set('s2EmpFirstName', formData2.S2EmpFirstName ?? '');
    payload.set('s2EmpMiddleName', formData2.S2EmpMiddleName ?? '');
    payload.set('s2EmpCitizenStatus', formData2.S2EmpCitizenStatus);
    payload.set('listADocumentTitle', formData2.ListADocumentTitle ?? '');
    payload.set('listAIssuingAuthority', formData2.ListAIssuingAuthority ?? '');
    payload.set('listADocumentNumber', formData2.ListADocumentNumber ?? '');
    payload.set('listAExpirationDateStr', formData2.ListAExpirationDateStr ?? '');
    payload.set('listADocumentTitle2', formData2.ListADocumentTitle2 ?? '');
    payload.set('listAIssuingAuthority2', formData2.ListAIssuingAuthority2 ?? '');
    payload.set('listADocumentNumber2', formData2.ListADocumentNumber2 ?? '');
    payload.set('listAExpirationDateStr2', formData2.ListAExpirationDateStr2 ?? '');
    payload.set('listADocumentTitle3', formData2.ListADocumentTitle3 ?? '');
    payload.set('listAIssuingAuthority3', formData2.ListAIssuingAuthority3 ?? '');
    payload.set('listADocumentNumber3', formData2.ListADocumentNumber3 ?? '');
    payload.set('listAExpirationDateStr3', formData2.ListAExpirationDateStr3 ?? '');
    payload.set('listBDocumentTitle', formData2.ListBDocumentTitle ?? '');
    payload.set('listBIssuingAuthority', formData2.ListBIssuingAuthority ?? '');
    payload.set('listBDocumentNumber', formData2.ListBDocumentNumber ?? '');
    payload.set('listBExpirationDateStr', formData2.ListBExpirationDateStr ?? '');
    payload.set('listCDocumentTitle', formData2.ListCDocumentTitle ?? '');
    payload.set('listCIssuingAuthority', formData2.ListCIssuingAuthority ?? '');
    payload.set('listCDocumentNumber', formData2.ListCDocumentNumber ?? '');
    payload.set('listCExpirationDateStr', formData2.ListCExpirationDateStr ?? '');
    payload.set('s2SignatureBinary', formData2.S2SignatureBinary ?? null);
    payload.set('s2SignatureDateStr', formData2.S2SignatureDateStr ?? '');
    payload.set('s2SignatureTitle', formData2.S2SignatureTitle ?? '');
    payload.set('s2SignatureFirstName', formData2.S2SignatureFirstName ?? '');
    payload.set('s2SignatureLastName', formData2.S2SignatureLastName ?? '');
    payload.set('s2BusinessName', formData2.S2BusinessName ?? '');
    payload.set('s2BusinessAddress', formData2.S2BusinessAddress ?? '');
    payload.set('s2BusinessCity', formData2.S2BusinessCity ?? '');
    payload.set('s2BusinessState', formData2.S2BusinessState ?? '');
    payload.set('s2Zip', formData2.S2Zip ?? '');
    payload.set('s2AdditionalInfo', formData2.S2AdditionalInfo ?? '');
    payload.set('s2EmployeeFirstDayStr', formData2.S2EmployeeFirstDayStr ?? '');
    payload.set('s3LastName', formData2.S3LastName ?? '');
    payload.set('s3FirstName', formData2.S3FirstName ?? '');
    payload.set('s3MiddleInitial', formData2.S3MiddleInitial ?? '');
    payload.set('s3RehireDateStr', formData2.S3RehireDateStr ?? '');
    payload.set('s3DocumentTitle', formData2.S3DocumentTitle ?? '');
    payload.set('s3DocumentNumber', formData2.S3DocumentNumber ?? '');
    payload.set('s3ExpirationDateStr', formData2.S3ExpirationDateStr ?? '');
    if (formData2.S3SignatureBinary != null) {
      payload.set('s3SignatureBinary', formData2.S3SignatureBinary ?? null);
    }
    payload.set('s3SignatureDateStr', formData2.S3SignatureDateStr ?? '');
    payload.set('s3SignatureName', formData2.S3SignatureName ?? '');
    payload.set('longitude', formData2.longitude ?? null);
    payload.set('latitude', formData2.latitude ?? null);
    payload.set('s2SignatureTypeSign', formData2.S2SignatureTypeSign ?? false);
    payload.set('s3SignatureTypeSign', formData2.S3SignatureTypeSign ?? false);
    payload.set('s2AltDocExamProcedure', formData2.S2AltDocExamProcedure ?? false);
    payload.set('s3AltDocExamProcedure', formData2.S3AltDocExamProcedure ?? false);
    payload.set('s3AdditionalInfo', formData2.S3AdditionalInfo ?? '');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    const options = { headers: headers };
    return this.http.post('/Hiring/UpdateI9ByOnboardIDPart2', payload, options).toPromise();
  }

  removeFileAttachment(fileAttachmentID: number) {
    return this.http
      .post('/Employee/RemoveFileAttachment', {
        fileAttachmentID: fileAttachmentID,
      })
      .toPromise();
  }

  getItem(checklistInstanceID: number) {
    const url = '/Checklist/GetItem?checklistInstanceID=' + checklistInstanceID;
    return this.http.get(url).toPromise();
  }

  getChoicesByTemplateItemID(checklistTemplateItemID: number, checklistInstance: number) {
    const url =
      '/Checklist/GetChoicesByTemplateItemID?checklistTemplateItemID=' +
      checklistTemplateItemID +
      '&checklistInstanceID=' +
      checklistInstance;
    return this.http.get(url).toPromise();
  }

  getInsCodes() {
    const url = '/Hiring/GetInsCodes';
    return this.http.get(url).toPromise();
  }

  getTimeRevGroup() {
    const url = '/Hiring/GetTimeRevGroup';
    return this.http.get(url).toPromise();
  }

  getHRCO() {
    const url = '/Employee/GetHRCO';
    return this.http.get(url).toPromise();
  }

  getACACode() {
    const url = '/Hiring/GetACACode';
    return this.http.get(url).toPromise();
  }

  getPRCo() {
    const url = '/Hiring/GetPRCo';
    return this.http.get(url).toPromise();
  }

  getCraft(data: number) {
    const url = '/Hiring/GetCraft?pRCo=' + data;
    return this.http.get(url).toPromise();
  }

  getClass(pRCo: number, craft: any) {
    const url = '/Hiring/GetClass?pRCo=' + pRCo + '&craft=' + craft;
    return this.http.get(url).toPromise();
  }

  getRehireDetailsByHRRef(hRRef: number, hRCo: number) {
    const url = '/Hiring/GetRehireDetailsByHRRef?HRRef=' + hRRef + '&HRCo=' + hRCo;
    return this.http.get(url).toPromise();
  }

  getPRDept(pRCo: number) {
    const url = '/Hiring/GetPRDept?pRCo=' + pRCo;
    return this.http.get(url).toPromise();
  }

  getCompanyGroups(data: number) {
    const url = '/Admin/GetCompanyGroups?pRCo=' + data;
    return this.http.get(url).toPromise();
  }

  getEarnCode(pRCo: number) {
    const url = '/Hiring/GetEarnCode?pRCo=' + pRCo;
    return this.http.get(url).toPromise();
  }

  initializeEmployee(
    onboardID: any,
    hRCoForInitialization: number,
    effectiveHireDateString: string,
    hRRef: number,
    pRCo: number,
    pRGroup: number,
    craft: string,
    classID: string,
    pRDept: string,
    earnCode: number,
    gender: string,
    wage: any,
    raceEthnic: string,
    insuranceCode: string,
    timesheetRevGroup: string,
    insState: string,
    codeSeries1: string,
    codeSeries2: string,
    employmentStatus: string,
    localCode: string,
    overtimeSchedule: string,
    pREmployee: number,
    occupCat: any,
    positionCode: any
  ) {
    return this.http
      .post('/Hiring/InitializeEmployee', {
        onboardID: onboardID,
        hRCoForInitialization: hRCoForInitialization,
        effectiveHireDateString: effectiveHireDateString,
        hRRef: hRRef,
        pRCo: pRCo,
        pRGroup: pRGroup,
        craft: craft,
        classID: classID,
        pRDept: pRDept,
        earnCode: earnCode,
        gender: gender,
        wage: wage,
        raceEthnic: raceEthnic,
        insuranceCode: insuranceCode,
        timesheetRevGroup: timesheetRevGroup,
        insState: insState,
        codeSeries1: codeSeries1,
        codeSeries2: codeSeries2,
        employmentStatus: employmentStatus,
        localCode: localCode,
        overtimeSchedule: overtimeSchedule,
        pREmployee: pREmployee,
        occupCat: occupCat,
        positionCode: positionCode,
      })
      .toPromise();
  }

  getEmploymentStatus(hRCo: number) {
    const url = '/Hiring/GetEmploymentStatus?hRCo=' + hRCo;
    return this.http.get(url).toPromise();
  }

  getLocalCode(pRCo: number) {
    const url = '/Hiring/GetLocalCode?pRCo=' + pRCo;
    return this.http.get(url).toPromise();
  }

  getOnboardDirectDepositsForOnboardee(): Promise<object> {
    const url = '/Hiring/GetOnboardDirectDepositsForOnboardee';
    return this.http.get<object>(url).toPromise();
  }

  getOnboardDirectDeposits(id: string): Promise<object> {
    const url = '/Hiring/GetOnboardDirectDeposits';
    const params = new HttpParams().set('onboardID', id);
    return this.http.get<object>(url, { params: params }).toPromise();
  }

  getW4Info(id: string, step: number): Promise<object> {
    if (step == 1) {
      const url = '/Hiring/GetW4InfoForOnboardee';
      return this.http.get<object>(url).toPromise();
    } else {
      const url = '/Hiring/GetW4Info';
      const params = new HttpParams().set('onboardID', id);
      return this.http.get<object>(url, { params: params }).toPromise();
    }
  }

  updateW4ByOnboardIDPart2(onboardID: any, employerNameAddress: string, officeCode: string, eIN: string, dateFirstEmploymentStr: string) {
    return this.http
      .post('/Hiring/UpdateW4ByOnboardIDPart2', {
        onboardID: onboardID,
        employerNameAddress: employerNameAddress,
        officeCode: officeCode,
        eIN: eIN,
        dateFirstEmploymentStr: dateFirstEmploymentStr,
      })
      .toPromise();
  }

  processOnboardingForms(
    recordID: number,
    onboardID: string,
    instanceIDs: number[],
    templateIDs: number[],
    filenames: string[],
    filetypes: string[],
    includeW4?: boolean,
    includeI9?: boolean,
    includeIden?: boolean,
    language?: string,
    applicantOnboardID?: string,
    includeDD?: boolean,
    includeEC?: boolean
  ) {
    return this.http
      .post('/Hiring/ProcessOnboardingForms', {
        recordID: recordID,
        onboardID: onboardID,
        instanceIDs: instanceIDs,
        templateIDs: templateIDs,
        filenames: filenames,
        filetypes: filetypes,
        includeW4: includeW4,
        includeI9: includeI9,
        includeIden: includeIden,
        language: language,
        applicantOnboardID: applicantOnboardID,
        includeDD: includeDD,
        includeEC: includeEC,
      })
      .toPromise();
  }

  updateItem(requestObj: any) {
    return this.http
      .post('/Checklist/UpdateItem', {
        checklistInstanceItemID: requestObj.checklistInstanceItemID,
        itemComments: requestObj.itemComments,
        itemResponse: requestObj.itemResponse,
        itemIsCorrected: requestObj.itemIsCorrected,
        correctedComments: requestObj.correctedComments,
        signatureDataStr: requestObj.signatureDataStr,
        typeSign: requestObj.typeSign,
        typeID: requestObj.typeID,
        time: requestObj.time,
        longitude: requestObj.longitude,
        latitude: requestObj.latitude,
        itemResponseDisplay: requestObj.itemResponseDisplay,
      })
      .toPromise();
  }

  fileAttachmentUpdateCaption(fileAttachmentID: any, attachmentCaption: string) {
    return this.http
      .post('/Checklist/FileAttachmentUpdateCaption', {
        fileAttachmentID: fileAttachmentID,
        attachmentCaption: attachmentCaption,
      })
      .toPromise();
  }

  deleteTask(onboardTaskID: number) {
    return this.http
      .post('/Hiring/DeleteTask', {
        onboardTaskID: onboardTaskID,
      })
      .toPromise();
  }

  unsubmitOnboardTasks(onboardID?: any) {
    return this.http
      .post('/Hiring/UnsubmitOnboardTasks', {
        onboardID: onboardID,
      })
      .toPromise();
  }

  deleteOnboarding(onboardID: any) {
    return this.http
      .post('/Hiring/DeleteOnboarding', {
        onboardID: onboardID,
      })
      .toPromise();
  }

  sendReminder(onboardID?: any) {
    return this.http
      .post('/Hiring/SendReminder', {
        onboardID: onboardID,
      })
      .toPromise();
  }

  beginOnboardingProcess(requestObj: any) {
    return this.http
      .post('/Hiring/BeginOnboardingProcess', {
        firstName: requestObj.firstName,
        lastName: requestObj.lastName,
        midName: requestObj.midName,
        suffix: requestObj.suffix,
        onboardingPIN: requestObj.onboardingPIN,
        email: requestObj.email,
        onboardTaskDefIDString: requestObj.onboardTaskDefIDString,
        hRRMKeyID: requestObj.hRRMKeyID,
        onboardProfileID: requestObj.onboardProfileID,
        reqID: requestObj.reqID,
        phone: requestObj.phone,
        address1: requestObj.address1,
        address2: requestObj.address2,
        city: requestObj.city,
        state: requestObj.state,
        zip: requestObj.zip,
        contact: requestObj.contact,
        contactSource: requestObj.contactSource,
        contactSourceNotes: requestObj.contactSourceNotes,
        cell: requestObj.cell,
        noHireCheck: requestObj.noHireCheck,
        country: requestObj.country,
        countryOther: requestObj.countryOther,
        ignoreLogout: requestObj.ignoreLogout,
      })
      .toPromise();
  }

  updateExpectedHireDate(onboardID: any, hireDate?: any) {
    return this.http
      .post('/Applicant/UpdateApplicantExpectedHireDate', {
        onboardId: onboardID,
        hireDateStr: hireDate,
      })
      .toPromise();
  }

  updateExpectedHRRef(onboardID: any, hRCo?: number, hRRef?: number, hRRMKeyID?: number) {
    return this.http
      .post('/Applicant/updateExpectedHRRef', {
        onboardId: onboardID,
        hRCo: hRCo,
        hRRef: hRRef,
        hRRMKeyID: hRRMKeyID,
      })
      .toPromise();
  }

  getVistaOptions(requestParam: string) {
    const url = '/Hiring/GetVistaOptions?' + requestParam;
    return this.http.get(url).toPromise();
  }

  clearOnboardingID() {
    return this.http.post('/Hiring/ClearOnboardingID', {}, { responseType: 'text' }).toPromise();
  }

  locationGet(): Promise<LookupOnboardLocations_Result[]> {
    const url = '/Hiring/LocationGet';
    return this.http.get<LookupOnboardLocations_Result[]>(url).toPromise();
  }

  logout() {
    const url = '/Hiring/Logout';
    return this.http.get(url).toPromise();
  }

  getInfoByOnboardID() {
    const url = '/Hiring/GetInfoByOnboardID';
    return this.http.get(url).toPromise();
  }

  updateSelfInfoByOnboardID(
    onboardID: any,
    raceEthnic: string,
    gender: string,
    veteran: string,
    disability: string,
    genderIdentity: string,
    genderIdentity_OtherDesc: string,
    veteran_Disabled: boolean,
    veteran_AFServiceMedal: boolean,
    veteran_ActiveDutyWartime: boolean,
    veteran_DischargeDate: any
  ) {
    return this.http
      .post('/Hiring/UpdateSelfInfoByOnboardID', {
        onboardID: onboardID,
        raceEthnic: raceEthnic,
        gender: gender,
        veteran: veteran,
        disability: disability,
        genderIdentity: genderIdentity,
        genderIdentity_OtherDesc: genderIdentity_OtherDesc,
        veteran_Disabled: veteran_Disabled,
        veteran_AFServiceMedal: veteran_AFServiceMedal,
        veteran_ActiveDutyWartime: veteran_ActiveDutyWartime,
        veteran_DischargeDate: veteran_DischargeDate,
      })
      .toPromise();
  }

  saveOnboardEmergencyContact(
    emContactID: number,
    contactName: string,
    relationship: string,
    homePhone: string,
    workPhone: string,
    address: string,
    city: string,
    state: string,
    zip: string,
    cellPhone: string,
    note: string
  ) {
    return this.http
      .post('/Hiring/SaveOnboardEmergencyContact', {
        emContactID: emContactID,
        contactName: contactName,
        relationship: relationship,
        homePhone: homePhone,
        workPhone: workPhone,
        address: address,
        city: city,
        state: state,
        zip: zip,
        cellPhone: cellPhone,
        note: note,
      })
      .toPromise();
  }

  saveOnboardDirectDeposit(
    onboardDirectDepositID: number,
    seq: any,
    routingID: string,
    bankAcct: string,
    method: string,
    amount: number,
    pct: any,
    acctType: string
  ) {
    return this.http
      .post('/Hiring/SaveOnboardDirectDeposit', {
        onboardDirectDepositID: onboardDirectDepositID,
        seq: seq,
        routingID: routingID,
        bankAcct: bankAcct,
        method: method,
        amount: amount,
        pct: pct,
        acctType: acctType,
      })
      .toPromise();
  }

  deleteOnboardDirectDeposit(onboardDirectDepositID: number) {
    return this.http
      .post('/Hiring/DeleteOnboardDirectDeposit', {
        onboardDirectDepositID: onboardDirectDepositID,
      })
      .toPromise();
  }

  deleteOnboardEmergencyContact(emContactID: number) {
    return this.http
      .post('/Hiring/DeleteOnboardEmergencyContact', {
        emContactID: emContactID,
      })
      .toPromise();
  }

  getProfiles(
    profileType?: string,
    pRCo?: number,
    onboardLocationID?: number,
    includesI9?: boolean
  ): Promise<LookupOnboardProfiles_Result[]> {
    const httpParams = new HttpParams()
      .set('profileType', profileType)
      .set('company', pRCo)
      .set('onboardLocationID', onboardLocationID)
      .set('includesI9', includesI9);
    return this.http.get<LookupOnboardProfiles_Result[]>('/Hiring/GetProfiles', { params: httpParams }).toPromise();
  }

  insertUpdateI9(formData: any) {
    return this.http
      .post('/Hiring/InsertUpdateI9', {
        s1LastName: formData.S1LastName,
        s1FirstName: formData.S1FirstName,
        s1MiddleInitial: formData.S1MiddleInitial,
        s1OtherLastName: formData.S1OtherLastName,
        s1Address: formData.S1Address,
        s1Apt: formData.S1Apt,
        s1City: formData.S1City,
        s1State: formData.S1State,
        s1Zip: formData.S1Zip,
        s1BirthDateStr: formData.S1BirthDateStr,
        s1SSN: formData.S1SSN,
        s1EmployeeEmail: formData.S1EmployeeEmail,
        s1EmployeePhone: formData.S1EmployeePhone,
        s1CitizenStatus: formData.S1CitizenStatus,
        s1AlienUSCISNumberQ3: formData.S1AlienUSCISNumberQ3,
        s1AlienExpirationStr: formData.S1AlienExpirationStr,
        s1AlienUSCISNumberQ4: formData.S1AlienUSCISNumberQ4,
        s1FormI94Admission: formData.S1FormI94Admission,
        s1ForeignPassportNumber: formData.S1ForeignPassportNumber,
        s1IssuanceCountry: formData.S1IssuanceCountry,
        s1SignatureBinary: formData.S1SignatureBinary,
        s1SignatureDateStr: formData.S1SignatureDateStr,
        isPreparerUsed: formData.IsPreparerUsed,
        preparerSignatureBinary: formData.PreparerSignatureBinary,
        preparerSignatureDateStr: formData.PreparerSignatureDateStr,
        preparerLastName: formData.PreparerLastName,
        preparerFirstName: formData.PreparerFirstName,
        preparerAddress: formData.PreparerAddress,
        preparerCity: formData.PreparerCity,
        preparerState: formData.PreparerState,
        preparerZip: formData.PreparerZip,
        longitude: formData.longitude,
        latitude: formData.latitude,
        IsPreparerUsedYN: formData.IsPreparerUsedYN,
        isReturnFromEmployerI9Form: formData.isReturnFromEmployerI9Form
      })
      .toPromise();
  }

  getTypeSign(type: any, name: any) {
    const url = '/Hiring/GetTypeSign?type=' + type + '&name=' + name;
    return this.http.get(url).toPromise();
  }

  insertUpdateW4(formData: any) {
    const payload = new URLSearchParams();
    payload.set('lastName', formData.LastName);
    payload.set('firstNameMiddleInitial', formData.FirstNameMiddleInitial);
    payload.set('address', formData.Address);
    payload.set('city', formData.City);
    payload.set('state', formData.State);
    payload.set('zip', formData.Zip);
    payload.set('sSN', formData.SSN);
    payload.set('maritalStatus', formData.MaritalStatus);
    payload.set('isDiffLastName', formData.IsDiffLastName);
    payload.set('isExempt', formData.IsExempt);
    payload.set('signDateStr', formData.SignDateStr);
    payload.set('signatureBinary', formData.SignatureBinary);
    payload.set('latitude', formData.Latitude);
    payload.set('longitude', formData.Longitude);
    payload.set('formLanguage', formData.FormLanguage);
    payload.set('typeSign', formData.TypeSign);
    payload.set('multiJobs2020', formData.MultiJobs2020);
    payload.set('otherIncome2020', formData.OtherIncome2020);
    payload.set('dependentAmt2020', formData.DependentAmt2020);
    payload.set('deductions2020', formData.Deductions2020);
    payload.set('totalAllowance', formData.TotalAllowance);
    payload.set('additionalAmount', formData.AdditionalAmount);
    payload.set('qualChildAmount', formData.QualChildAmount);
    payload.set('otherDependentAmount', formData.OtherDependentAmount);
    payload.set('isReturnFromEmployerW4Form', formData.isReturnFromEmployerW4Form);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    const options = { headers: headers };
    return this.http.post('/Hiring/InsertUpdateW4', payload, options).toPromise();
  }

  getLoginStatus() {
    const url = '/Hiring/GetLoginStatus';
    return this.http.get(url, { responseType: 'text' }).pipe();
  }

  getReqDetails(reqID: any) {
    const url = '/Careers/GetReqDetails?reqID=' + reqID;
    return this.http.get(url).toPromise();
  }

  reqSpecQuesAnswerGet(reqID: any, onboardID?: any) {
    const url = '/Applicant/ReqSpecQuesAnswerGet?reqID=' + reqID;
    return this.http.get(url).toPromise();
  }

  reqSpecQuesAnswerAddEdit(reqSpecAnswerID: number, reqSpecQuesID: number, questionText: string, answerText: string) {
    return this.http
      .post('/Applicant/ReqSpecQuesAnswerAddEdit', {
        reqSpecAnswerID: reqSpecAnswerID,
        reqSpecQuesID: reqSpecQuesID,
        questionText: questionText,
        answerText: answerText,
      })
      .toPromise();
  }

  deleteOnboardByID(onboardID?: any) {
    return this.http
      .post('/Hiring/DeleteOnboardByID', {
        onboardID: onboardID,
      })
      .toPromise();
  }

  submitOnboardTasks(onboardID?: any) {
    return this.http
      .post('/Hiring/SubmitOnboardTasks', {
        onboardID: onboardID,
      })
      .toPromise();
  }

  changeOnboardProfile(onboardID: any, newOnboardProfileID: number) {
    return this.http
      .post('/Hiring/ChangeOnboardProfile', {
        onboardID: onboardID,
        newOnboardProfileID: newOnboardProfileID,
      })
      .toPromise();
  }

  validateAddress(address: string, city: string, state: string, zip: string) {
    const url = '/Hiring/ValidateAddress?streetAddress=' + address + '&city=' + city + '&state=' + state + '&postalCode=' + zip;
    return this.http.get(url).toPromise();
  }

  downloadTaskRDL(onboardingID: any, fullName: any, view: any, rawData: any) {
    let url = '/Hiring/DownloadTaskRDL';
    let temp = '';
    if (onboardingID != null) {
      temp += '?onboardingID=' + onboardingID;
    }
    if (fullName != null) {
      temp.length == 0 ? (temp += '?') : (temp += '&');
      temp += 'fullName=' + fullName;
    }
    if (view != null) {
      temp.length == 0 ? (temp += '?') : (temp += '&');
      temp += 'view=' + view;
    }
    if (rawData != null) {
      temp.length == 0 ? (temp += '?') : (temp += '&');
      temp += 'rawData=' + rawData;
    }
    url += temp;
    return this.http.get(url).toPromise();
  }

  onInitializeBirdDogRecord(requestObj: any) {
    return this.http
      .post('/Hiring/ONInitializeBirdDogRecord', {
        hRCoForInitialization: requestObj.hRCoForInitialization,
        effectiveHireDateStr: requestObj.effectiveHireDateStr,
        pRCo: requestObj.pRCo,
        pRGroup: requestObj.pRGroup,
        craft: requestObj.craft,
        classID: requestObj.classID,
        pRDept: requestObj.pRDept,
        earnCode: requestObj.earnCode,
        email: requestObj.email,
        account1: requestObj.account1,
        account2: requestObj.account2,
        account3: requestObj.account3,
        accountType1: requestObj.accountType1,
        accountType2: requestObj.accountType2,
        accountType3: requestObj.accountType3,
        addressLine1: requestObj.addressLine1,
        addressLine2: requestObj.addressLine2,
        allowancesandDeductionConfirmation: requestObj.allowancesandDeductionConfirmation,
        amount1: requestObj.amount1,
        amount2: requestObj.amount2,
        amount3: requestObj.amount3,
        amountType1: requestObj.amountType1,
        amountType2: requestObj.amountType2,
        amountType3: requestObj.amountType3,
        businessUnit: requestObj.businessUnit,
        confirmationofStateResidency: requestObj.confirmationofStateResidency,
        countryofResidence: requestObj.countryofResidence,
        countyWithholding: requestObj.countyWithholding,
        dateExported: requestObj.dateExported,
        dateofBirth: requestObj.dateofBirth,
        directDeposit: requestObj.directDeposit,
        emergencyContact: requestObj.emergencyContact,
        emergencyContactHomePhoneNumber: requestObj.emergencyContactHomePhoneNumber,
        emergencyContactMobilePhoneNumber: requestObj.emergencyContactMobilePhoneNumber,
        emergencyContactRelationship: requestObj.emergencyContactRelationship,
        emergencyContactWorkPhoneNumber: requestObj.emergencyContactWorkPhoneNumber,
        employeeCity: requestObj.employeeCity,
        employeeEmailAddress: requestObj.employeeEmailAddress,
        employeeNumber: requestObj.employeeNumber,
        federalAddlAllowances: requestObj.federalAddlAllowances,
        hRRef: requestObj.hRRef,
        federalAllowances: requestObj.federalAllowances,
        federalExemption: requestObj.federalExemption,
        federalFilingStatus: requestObj.federalFilingStatus,
        federalPerjuryConfirmation: requestObj.federalPerjuryConfirmation,
        firstName: requestObj.firstName,
        gender: requestObj.gender,
        homePhoneNumber: requestObj.homePhoneNumber,
        i9Assistance: requestObj.i9Assistance,
        institution1: requestObj.institution1,
        institution2: requestObj.institution2,
        institution3: requestObj.institution3,
        lastName: requestObj.lastName,
        locationName: requestObj.locationName,
        locationNumber: requestObj.locationNumber,
        maidenName: requestObj.maidenName,
        maritalStatus: requestObj.maritalStatus,
        middleName: requestObj.middleName,
        mobilePhoneNumber: requestObj.mobilePhoneNumber,
        nameSuffix: requestObj.nameSuffix,
        preferredName: requestObj.preferredName,
        primaryState: requestObj.primaryState,
        raceEthnicity: requestObj.raceEthnicity,
        reasonableAccommodations: requestObj.reasonableAccommodations,
        route1: requestObj.route1,
        route2: requestObj.route2,
        route3: requestObj.route3,
        socialSecurityNumber: requestObj.socialSecurityNumber,
        state: requestObj.state,
        stateExemptionTotal: requestObj.stateExemptionTotal,
        stateWithholding: requestObj.stateWithholding,
        stateWithholdingPercentage: requestObj.stateWithholdingPercentage,
        veteran: requestObj.veteran,
        zipCode: requestObj.zipCode,
        wage: requestObj.wage,
        insuranceCode: requestObj.insuranceCode,
        timesheetRevGroup: requestObj.timesheetRevGroup,
        systemID: requestObj.systemID,
        TasksCompleted: requestObj.TasksCompleted,
      })
      .toPromise();
  }

  onboardI9GetSupA(onboardID: any) {
    const url = '/Hiring/OnboardI9GetSupA?onboardID=' + onboardID;
    return this.http.get(url).toPromise();
  }

  onboardI9SupAInsertUpdate(objData: any) {
    return this.http
      .post('/Hiring/OnboardI9SupAInsertUpdate', {
        objData: objData,
      })
      .toPromise();
  }

  onboardI9SupADelete(onboardID: any, seq: any) {
    return this.http
      .post('/Hiring/OnboardI9SupADelete', {
        onboardID: onboardID,
        seq: seq,
      })
      .toPromise();
  }

  getTagsByOnboard(onboardID: any) {
    const url = '/Hiring/GetTagsByOnboard?onboardID=' + onboardID;
    return this.http.get(url).toPromise();
  }

  tagsManage(isManage: boolean, reqID?: any) {
    const url = '/Hiring/TagsManage?isManage=' + isManage + '&reqID=' + reqID;
    return this.http.get(url).toPromise();
  }

  addTagsByOnboard(onboardID: any, tagID: number) {
    return this.http
      .post('/Hiring/AddTagsByOnboard', {
        onboardID: onboardID,
        tagID: tagID,
      })
      .toPromise();
  }

  deleteTagsByOnboard(onboardID: any, tagID: number) {
    return this.http
      .post('/Hiring/DeleteTagsByOnboard', {
        onboardID: onboardID,
        tagID: tagID,
      })
      .toPromise();
  }

  addUpdateProfile(
    onboardProfileID?: number,
    onboardProfileName?: string,
    onboardProfileIsDefault?: boolean,
    profileType?: string,
    isApplyOnline?: boolean,
    onboardChecklistTemplateID?: number,
    company?: number,
    onboardLocationID?: number,
    includeW4 = false,
    includeI9 = false,
    includeIdentification = false,
    includeDirectDeposit = 0,
    includeEmergencyContacts = false
  ) {
    return this.http
      .post('/Hiring/AddUpdateProfile', {
        onboardProfileID: onboardProfileID,
        onboardProfileName: onboardProfileName,
        onboardProfileIsDefault: onboardProfileIsDefault,
        profileType: profileType,
        isApplyOnline: isApplyOnline,
        onboardChecklistTemplateID: onboardChecklistTemplateID,
        company: company,
        onboardLocationID: onboardLocationID,
        includeW4: includeW4,
        includeI9: includeI9,
        includeIdentification: includeIdentification,
        includeDirectDeposit: includeDirectDeposit,
        includeEmergencyContacts: includeEmergencyContacts,
      })
      .toPromise();
  }

  defaultsInsertUpdate(
    onboardTaskIsRequired?: boolean,
    checklistTemplateID?: number,
    bulletinID?: number,
    onboardTaskDefID?: number,
    onboardProfileID?: number,
    onboardTaskIsDefault?: boolean
  ) {
    return this.http
      .post('/Hiring/DefaultsInsertUpdate', {
        onboardTaskIsRequired: onboardTaskIsRequired,
        checklistTemplateID: checklistTemplateID,
        bulletinID: bulletinID,
        onboardTaskDefID: onboardTaskDefID,
        onboardProfileID: onboardProfileID,
        onboardTaskIsDefault: onboardTaskIsDefault,
      })
      .toPromise();
  }

  reqStageDelete(reqStageID?: number) {
    return this.http
      .post('/Hiring/ReqStageDelete', {
        reqStageID: reqStageID,
      })
      .toPromise();
  }

  reqStageAddEdit(
    reqStageID?: number,
    reqStageDescription?: string,
    reqStageSeq?: number,
    checklistTemplateID?: number,
    isStageActive?: boolean
  ) {
    return this.http
      .post('/Hiring/ReqStageAddEdit', {
        reqStageID: reqStageID,
        reqStageDescription: reqStageDescription,
        reqStageSeq: reqStageSeq,
        checklistTemplateID: checklistTemplateID,
        isStageActive: isStageActive,
      })
      .toPromise();
  }

  locationAddEdit(onboardLocationID?: number, onboardLocationName?: string) {
    return this.http
      .post('/Hiring/LocationAddEdit', {
        onboardLocationID: onboardLocationID,
        onboardLocationName: onboardLocationName,
      })
      .toPromise();
  }

  locationUserGroupAdd(onboardLocationID?: number, userGroupID?: number) {
    return this.http
      .post('/Hiring/LocationUserGroupAdd', {
        onboardLocationID: onboardLocationID,
        userGroupID: userGroupID,
      })
      .toPromise();
  }

  locationGetUserGroups(onboardLocationID?: number) {
    const url = '/Hiring/LocationGetUserGroups?onboardLocationID=' + onboardLocationID;
    return this.http.get(url).toPromise();
  }

  locationUserGroupUpdate(onboardLocationID?: number, userGroupID?: number, accessType?: number, onboardLocationUserGroupID?: number) {
    return this.http
      .post('/Hiring/LocationUserGroupUpdate', {
        onboardLocationID: onboardLocationID,
        userGroupID: userGroupID,
        accessType: accessType,
        onboardLocationUserGroupID: onboardLocationUserGroupID,
      })
      .toPromise();
  }

  locationUserGroupDelete(onboardLocationUserGroupID?: number) {
    return this.http
      .post('/Hiring/LocationUserGroupDelete', {
        onboardLocationUserGroupID: onboardLocationUserGroupID,
      })
      .toPromise();
  }

  locationDelete(onboardLocationID?: number) {
    return this.http
      .post('/Hiring/LocationDelete', {
        onboardLocationID: onboardLocationID,
      })
      .toPromise();
  }

  deleteProfile(onboardProfileID: number) {
    return this.http
      .post('/Hiring/DeleteProfile', {
        onboardProfileID: onboardProfileID,
      })
      .toPromise();
  }

  updateAssignedStages(onboardProfileID?: number, assignedReqStageIDString?: string) {
    return this.http
      .post('/Hiring/UpdateAssignedStages', {
        onboardProfileID: onboardProfileID,
        assignedReqStageIDString: assignedReqStageIDString,
      })
      .toPromise();
  }

  tagsAddEdit(newDescription: string, newDistrict: string, tagID: number) {
    return this.http
      .post('/Hiring/TagsAddEdit', {
        description: newDescription,
        district: newDistrict,
        tagID: tagID,
      })
      .toPromise();
  }

  tagsDelete(tagID: number) {
    return this.http
      .post('/Hiring/TagsDelete', {
        tagID: tagID,
      })
      .toPromise();
  }

  getPositionCodes(co: any) {
    const url = '/Hiring/GetPositionCodes?co=' + co;
    return this.http.get(url).toPromise();
  }

  getOccupationCategories(co: any) {
    const url = '/Hiring/GetOccupationCategories?co=' + co;
    return this.http.get(url).toPromise();
  }

  jobTargetGetCompany() {
    const url = '/Hiring/JobTargetGetCompany';
    return this.http.get(url).toPromise();
  }

  jobTargetJobEdit(jobString: string) {
    return this.http
      .post('/Hiring/JobTargetJobEdit', {
        jobString: jobString,
      })
      .toPromise();
  }

  getJobTargetSSOLink() {
    return this.http.post('/Hiring/GetJobTargetSSOLink', {}).toPromise();
  }

  jobCreate(jobString: any) {
    return this.http
      .post('/Hiring/JobTargetJobCreate', {
        jobString: jobString,
      })
      .toPromise();
  }

  setJobTargetID(reqID: any, jobTargetID: any) {
    return this.http
      .post('/Hiring/SetJobTargetID', {
        reqID: reqID,
        jobTargetID: jobTargetID,
      })
      .toPromise();
  }

  stopJobTargetPost(jobTargetID: any) {
    return this.http
      .post('/Hiring/StopJobTargetPost', {
        jobTargetID: jobTargetID,
      })
      .toPromise();
  }

  getJobTargetJobDetails(jobTargetID: any, reqID?: any) {
    return this.http
      .post('/Hiring/GetJobTargetJobDetails', {
        jobTargetID: jobTargetID,
        reqID: reqID,
      })
      .toPromise();
  }

  startEverifySession(onboardID: any) {
    return this.http.get('/Hiring/StartEverifySession?onboardID=' + onboardID).toPromise();
  }
  getJobReqSearchExternal(requestParams: string) {
    const url = '/Careers/GetJobReqSearchExternal' + requestParams;
    return this.http.get(url).toPromise();
  }

  getLocationFilter() {
    const url = '/Careers/GetLocationFilter';
    return this.http.get(url).toPromise();
  }

  getReqFilterChoices(filterType: string): Promise<Filter[]> {
    const url = '/Careers/GetReqFilterChoices?filterType=' + filterType;
    return this.http.get<Filter[]>(url).toPromise();
  }

  getReqDetailsByIdAndAuthToken(reqID: any, reqApplyToken: any) {
    const url = '/Careers/GetReqDetails?reqID=' + reqID + '&reqApplyToken=' + reqApplyToken;
    return this.http.get(url).toPromise();
  }

  setJobTargetAttributes(onboardID: any, source: string, jtochash: string, jtocprof: string) {
    return this.http
      .post('/Hiring/SetJobTargetAttributes', {
        onboardId: onboardID,
        source: source,
        jtochash: jtochash,
        jtocprof: jtocprof,
      })
      .toPromise();
  }

  processI9AuditReport(onboardID: string, employeeName: string): Observable<ReportGenerationApiResponse> {
    return this.http.post<ReportGenerationApiResponse>('/Hiring/ProcessI9AuditReport', {
      onboardId: onboardID,
      employeeName: employeeName,
    });
  }
  processI9AuditReportBulk(i9AudtitReportRequests: I9AuditReportBulk[]): Observable<ReportGenerationApiResponse> {
    return this.http.post<ReportGenerationApiResponse>('/Hiring/ProcessI9AuditReportBulk', {
      i9AudtitReportRequests: i9AudtitReportRequests,
    });
  }

  getOnboardEmployeesWithI9(): Observable<I9Employees_Result[]> {
    const url = '/Hiring/GetEmployeesWithI9Audit';
    return this.http.get<I9Employees_Result[]>(url);
  }

  async addW4EmployerComments(onboardID: string, employerComment: string): Promise<ApiResponse> {
    const url = '/Hiring/AddW4EmployerComments';
    const payload = {
      onboardID: onboardID,
      employerComment: employerComment,
    };
    return this.http.post<ApiResponse>(url, payload).toPromise();
  }

  async addI9EmployerComments(onboardID: string, employerComment: string): Promise<ApiResponse> {
    const url = '/Hiring/AddI9EmployerComments';
    const payload = {
      onboardID: onboardID,
      employerComment: employerComment,
    };
    return this.http.post<ApiResponse>(url, payload).toPromise();
  }
}
